import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import { MqTablet } from '~theme/media';

export const StyledPreviewStep = styled.div`
	display: flex;
	flex-direction: column;
	gap: var(--gap-x6);
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: var(--gap-x4);
	${MqTablet} {
		flex-direction: row;
	}
`;

export const cardButton = css`
	height: 316px;
`;

export const InfoBlock = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 16px;
	border-radius: var(--radius-s);
	background-color: var(--color-grey-10-solid);
	gap: var(--gap-x2);
`;

export const InfoBlocksWrapper = styled.div`
	display: flex;
	width: 100%;
	flex-direction: column;
	gap: var(--gap-x4);
`;
